export { useInstallationStore } from "./installationDetails";
export { useGlobalStore } from "./global";
export { useNumberOfDaysStore } from "./numberOfDays";
